import { Navbar } from '../../components/Navbar/Navbar';
import Tickers from '../../components/Tickers/Tickers';
import img0 from '../../utils/images/aboutUs.jfif';
import { Card, CardContent, CardMedia, Container, Grid, Typography, Box, Button } from '@mui/material';
import img2 from '../../utils/images/eventCard.jpg';
import { useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer/Footer';
// import december from '../../newspdf/december.pdf';
// import august from '../../newspdf/august.pdf';
// import january from '../../newspdf/january.pdf';
// import june2022 from '../../newspdf/june2022.pdf';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { getNewsletter } from '../../API/api';

function Newsletter() {
  const navigate = useNavigate();

  const viewData = (docURL) => {
    window.open(docURL)
    // window.open(docURL);
  };

  const [newsletterInfo, setNewsletterInfo] = useState([]);

  useEffect(() => {
    getData();
  }, []);
  //  getData();
  const getData = async () => {
    axios
      .get(getNewsletter)
      .then(response => {
        setNewsletterInfo(response.data.data);
      })
      .catch(error => {
        console.log(error);
      });
  };


  // console.log(newsletterInfo)

  return (
    <div>
      <Navbar></Navbar>
      {/* <Tickers></Tickers> */}
      <div
        style={{
          width: '100%',
          display: 'flex',
          height: '457px',
          paddingTop: '100px',
          background: `rgba(0, 0, 0,0.8) url(${img0})`,

          backgroundSize: 'cover',
          position: 'relative',
          backgroundPosition: 'center',
          zIndex: -1,
          flexDirection: 'column',
          backgroundBlendMode: 'darken',

          // marginTop: '20px',
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontFamily: 'Poppins',
            color: '#FFFFFF',
            justifyContent: 'center',
            width: '100%',
            display: 'flex',
            marginTop: '100px',
            fontWeight: 'bold',
            fontSize: '3.2rem',
          }}
        >
          Newsletter
        </Typography>
      </div>
      <Box sx={{ flexGrow: 1, px: [0, 0, 20], paddingTop: 4, backgroundColor: '#fcfcfc' }}>
        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 12, sm: 12, md: 12 }}>


          {
            newsletterInfo?.map(data => (
              <Grid item xs={12} sm={12} md={4} sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                <Card
                  sx={{
                    marginBottom: 2,
                    boxShadow: '0px 3px 45px #00000008',
                    height: '330px',
                    width: '519px',
                    marginRight: 1,
                    overflow: 'scroll',
                  }}
                >
                  <div>
                    <CardContent sx={{}}>
                      <Typography
                        sx={{
                          color: '#ed7632',
                          fontSize: '17px',
                          fontFamily: 'Poppins',
                          backgroundColor: '#fef7f3',
                          borderRadius: '22px',
                          padding: '10px 14px',
                          marginTop: '20px',
                          height: '41px',
                          width: '60%',
                          textAlign: 'center',
                        }}
                      >
                        {data.date}
                      </Typography>
                      <Typography sx={{ color: '#151515', fontFamily: 'Poppins', marginTop: '18px', fontWeight: 'bold' }}>
                        {data.title}
                      </Typography>
                      <Typography
                        sx={{
                          color: ' #62392B',
                          fontFamily: 'Poppins',
                          fontSize: '17px',
                          marginTop: '10px',
                        }}
                      >
                        {data.description}
                      </Typography>
                    </CardContent>
                  </div>
                  <Button
                    variant="outlined"
                    sx={{
                      color: '#FF7345',
                      marginLeft: '30px',
                      marginBottom: '20px',
                      border: `1px solid #FF7345`,
                      '&:hover': { border: `1px solid #f83d0085` },
                    }}
                    // target="_blank"
                    onClick={() => viewData(data.docURL)}
                  >
                    Read More
                  </Button>
                </Card>
              </Grid>
            ))
          }


        </Grid>
      </Box>
      <br></br>
      <br></br>
      <Footer></Footer>
    </div>
  );
}

export default Newsletter;
